export default "__VITE_ASSET__C_5ecn4o__"